<template>
  <div class="lotti-activate-account-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">

          <div class="lotti-module-title">Account Aktivieren</div>

          <el-form :model="activateForm" :rules="activateRules" label-width="170px" ref="activateForm" class="lotti-module-form">

            <el-form-item label="Logopädin:">
              <span class="lotti-activate-therapist-name">{{therapistName}}</span>
            </el-form-item>

            <el-form-item label="Neues Passwort:" prop="passwordNew" autocomplete="off">
              <el-input type="password" placeholder="Neues Passwort" v-model="activateForm.passwordNew" show-password></el-input>
            </el-form-item>

            <el-form-item label="Passwort wiederholen:" prop="passwordNewConfirm" autocomplete="off">
              <el-input type="password" placeholder="Neues Passwort wiederholen" v-model="activateForm.passwordNewConfirm" show-password></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="isLoading" @click="submitData">Aktivieren</el-button>
            </el-form-item>

          </el-form>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from '../../main.js';

//loading modules for dashboard-tiles
import notification from "../../Helpers/NotificationHelper";
import validation from "../../Helpers/ValidationHelper";
import routerHelper from "../../Helpers/RouterHelper";


export default {

  data() {

    let confirmValidate = (rule, value, callback) => {
      if (value !== this.activateForm.passwordNew) {
        callback(new Error('Das Passwort ist nicht identisch!'));
      } else {
        callback();
      }
    };

    return {
      isLoading: false,
      activationCode: null,
      therapistName: null,

      activateForm: {
        passwordNew: null,
        passwordNewConfirm: null,
      },

      activateRules: {
        passwordNew: [
          validation.getRequiredValidationObject('change'),
          validation.getContainNumberValidationObject('change'),
          validation.getContainUpperValidationObject('change'),
          validation.getMinLengthValidationObject(8, 'change'),
          validation.getContainLowerValidationObject('change'),
          validation.getContainSymbolValidationObject('change'),
        ],
        passwordNewConfirm: [
          validation.getRequiredValidationObject('change'),
          {validator: confirmValidate, trigger: 'change'}
        ]
      },
    }
  },

  methods: {

    //get therapist name by activation code!
    getTherapistName() {
      Vue.http.get(
          'api/v1/get-therapist-by-code',
          {
            params: {
              code: this.activationCode,
            }
          }
      ).then(response => {

        //on success, set retrieved therapist name
        this.therapistName = response.data.name

      }, error => {

        //on error, the hash code is invalid: push route back to /
        routerHelper.routerPushToLogin(this)
      })
    },

    submitData() {

      this.$refs['activateForm'].validate((valid) => {

        if (valid) {

          //set button in loading status
          this.isLoading = true;

          Vue.http.post(
              'api/v1/activate-account',
              {
                password: this.activateForm.passwordNew,
                code: this.activationCode,
              }
          ).then(response => {

            //remove the query parameter by pushing to /
            routerHelper.routerPushToLogin(this)

            //show success msg
            notification.showSuccess(this, 'Profil wurden erfolgreich aktiviert');

          }, error => {

            //remove the query parameter by pushing to /
            routerHelper.routerPushToLogin(this)

            notification.showError(this, 'Profil konnte nicht aktiviert werden');
          })
        }
      })
    },

  },

  beforeMount() {

    // get email address activation code
    this.activationCode = String(this.$route.query.code) || null;

    //if no code, push route to /
    if (!this.activationCode) {
      routerHelper.routerPushToLogin(this)
    }

    //get name of activate therapist
    this.getTherapistName()
  }
}

</script>